<template>
    <div class="container">
        <div class="row form-group">
            <amf-input label="Number of insured participants in medical plans only " :columns="1" v-model="numberOfInsured" :validator="$v.numberOfInsured" />
            <amf-checkbox label="Is COBRA EDI" v-model="isCobraEdi" :disabled="!can.editEdi" :columns="3"/>
            <amf-checkbox label="Employer wants Ameriflex to bill for Retiree and/or Leave of Absence premiums (not COBRA related)" :columns="3" v-model="hasCobraSpm" />        
            <amf-checkbox v-if="!hasCobraRenewal" label="There is currently an enrolled or eligible to enroll COBRA population for this employer" :columns="3" v-model="hasCobraLegacy" />
            <amf-checkbox label="State Continuation (MN, NY, or IL Only) *Refers to an extension of the Federal COBRA benefits after the initial period of 18 months of Federal COBRA would normally end. Additional fees may apply." :columns="3" v-model="stateContinuation" />
        </div>
        <div v-if="stateContinuation" class="row form-group row-mw">
            <amf-multiple-select label='State(s) to Administer' v-model="selectedCobraStates" :options="cobraStates" :columns="3" :validator="$v.selectedCobraStates"/>
        </div>
        <div class="row row-mw">
            <amf-textarea label="Cobra Processing Notes" :columns="3" v-model="cobraNotes" />
        </div>
    </div>
</template>

<script>
export default ({
    data(){
        return{
            numberOfInsured: null,
            hasCobraSpm: false,
            hasCobraLegacy: false,
            isCobraEdi: false,
            cobraNotes: null,
            stateContinuation: false,
            selectedCobraStates: [],
            hasCobraRenewal: false,
            cobraStates: ['IL', 'MN', 'NY'],
            amfOptions: { layout: "two-column" },
        };
    },
    computed: {
        ...amfx.map('employer', 'employerId'),        
        ...amfx.map("session", "isInternalUser"),
        title(){
            return "Cobra Setup";
        },
        readOnly() {
            return !this.can.editCobra;
        },
        buttons(){
            return !this.readOnly ? 'Save/Cancel': '';
        },
    },
    async created(){        
        await this.getCobraConfig();        
    },
    methods:{
        async getCobraConfig(){
            let config = await romeApi.get(`employer/${this.employerId}/cobra`);
            let hasRenewal = await romeApi.get(`employer/${this.employerId}/order/cobra/has-renewal`);
            
            this.numberOfInsured = config.numberOfInsured;
            this.hasCobraSpm = config.hasCobraSpm || false;
            this.hasCobraLegacy = config.hasCobraLegacy || false;
            this.cobraNotes = config.cobraNotes;
            this.stateContinuation = !!config.cobraStateContinuation;
            if(this.stateContinuation) {
                this.selectedCobraStates = config.cobraStateContinuation.split(',');
            }

            this.hasCobraRenewal = hasRenewal;

            this.isCobraEdi = this.$store.state.employer.isCobraEdi;            
        },
        async save(){            
            await romeApi.post(`employer/${this.employerId}/cobra`, this.$data);
            await this.$store.dispatch("employer/load", {employerId: this.employerId, refreshSameEmployer: true}),
            await this.$store.dispatch('cobraConfig/load', {employerId: this.employerId, force: true});
            toastService.success(`Employer COBRA Setup updated.`);
        }
    },
    validations() {
        return {
            numberOfInsured: v.build(v.required(), v.custom(x => x > 0, "Must be greater than zero")),
            selectedCobraStates: v.build(v.requiredIf(() => {
                return this.stateContinuation === true;
            }))
        }
    },
})
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/cobra/CobraSetup.vue